// extracted by mini-css-extract-plugin
export var messageSideLeft = "_md-1";
export var messageSideRight = "_md-2";
export var subscribeToBackInStockBubbleContainer = "_md-0";